export const CAPTCHA_SCRIPT_LOAD_ERROR = 'captchaScriptLoadError'
